import { StaffAuthService } from "./shared/services/staff-auth.service";
import {
  chilPath,
  menuHome,
  menuLoginPhone,
  ugiftPath,
} from "app/config/config";
import { Component, OnInit } from "@angular/core";
import { Platform } from "@ionic/angular";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { Config, menuReport } from "./config/config";
import { MenuController } from "@ionic/angular";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { UnileverUserInfo } from "./shared/interfaces/authUserInfo";
import { AppMessages } from "./shared/consts/app-messages";
import {
  ALLOW_BROWSERS_ANDROID,
  ALLOW_BROWSERS_IOS,
  AppConsts,
} from "./shared/consts/app-consts";
import { BaseComponent } from "./shared/common/base-component";
import { FpModel } from "./shared/model/fp";
import { environment } from "environments/environment";
import { filter } from "rxjs/operators";
import { GiveGiftService } from "./give-gift/share/services/give-gift.service";
import { CampaignInfo } from "./shared/interfaces/campaign-info";
import { detectDeviceInfo } from "./shared/util/CommonUtil";
declare const window: any;
declare var $: any;
@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent extends BaseComponent implements OnInit {
  public supportedDevice: boolean = true;
  public currentUser: UnileverUserInfo;
  public appPages = Config.menu;
  isRole: boolean = false;
  phoneNumber: string;
  deviceInfo: FpModel;
  public isShowPopupApp = false;
  public errormassage = AppMessages.NOCAMPAIGN_SESSIONEXPIRE;
  public errormassage1 = AppMessages.INVALID_CAMPAIGN;
  public previousUrl = "";
  public currentUrl = "";
  private fingerprint = "";
  private campaignInfo: CampaignInfo;
  static isValidateBrowser: boolean = false;

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private staffServices: StaffAuthService,
    public menuCtrl: MenuController,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private giveGiftService: GiveGiftService
  ) {
    super();
    router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.router.navigate([], { queryParams: {} });
        this.previousUrl = this.currentUrl;
        this.currentUrl = window.location.href;
        if (!this.fingerprint) {
          this.fingerprint = localStorage.getItem("_fp");
        }
        window.UTopSDK.Tracking.logPageView({
          page_location: this.currentUrl,
          page_referrer: this.previousUrl || window.location.href,
          fingerprint: this.fingerprint,
        });
      });
  }

  initializeApp() {
    $("#popup-check-logout").addClass("hidden");
    $("#popup-check-campaignactive").addClass("hidden");
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
    this.staffServices.currentUser.subscribe((x) => {
      this.currentUser = x;
      if (this.staffServices.currentUserValue) {
        window.UTopSDK.Tracking.setUserId(x.uid || "");
        this.appPages = Config.registerMenu;
      } else {
        // if(window.location.href.indexOf('check-fp') < 0){
        //   setTimeout(() => {
        //     this.router.navigate([`${menuLoginPhone.path}`]);
        //   }, 500);
        // }
      }
    });
  }

  async ngOnInit() {
    try {
      this.deviceInfo = JSON.parse(localStorage.getItem("fpFull"));
      if (this.deviceInfo?.incognito && environment.isEnableBlockBrowser) {
        this.router.navigate([ugiftPath.browser.path]);
      }
    } catch (error) {}
    this.campaignInfo = await this.giveGiftService
      .getCampaignInfo()
      .toPromise();
    AppComponent.isValidateBrowser = this.campaignInfo.isValidateBrowser;
    var isMobile = false;
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      isMobile = true;
    }
    var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
      windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
      iosPlatforms = ["iPhone", "iPad", "iPod"],
      os = null;
    if (macosPlatforms.indexOf(platform) !== -1) {
      os = "Mac OS";
      if (navigator.maxTouchPoints > 5) {
        isMobile = true;
      }
      isMobile = false;
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = "iOS";
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = "Windows";
      isMobile = false;
    } else if (/Android/.test(userAgent)) {
      os = "Android";
    } else if (!os && /Linux/.test(platform)) {
      os = "Linux";
      isMobile = false;
    }
    if (!isMobile) {
      this.supportedDevice = true;
    }
    if (!this.supportedDevice) {
      this.setBodyBgClass("bgr-desktop");
    }

    if (this.campaignInfo.isValidateBrowser) {
      detectDeviceInfo((info) => {
        console.log("info >>>", info);
        const fpFull: FpModel = JSON.parse(localStorage.getItem("fpFull"));
        if (fpFull?.browserName && fpFull?.os) {
          if (info?.os === "ios") {
            if (
              !ALLOW_BROWSERS_IOS.includes(info?.browserName) &&
              environment.isEnableBlockBrowser
            ) {
              this.router.navigate([ugiftPath.browserIphone.path]);
              return false;
            }
          } else {
            if (info?.os === "android") {
              if (
                !ALLOW_BROWSERS_ANDROID.includes(info?.browserName) &&
                environment.isEnableBlockBrowser
              ) {
                this.router.navigate([ugiftPath.browserAndroid.path]);
                return false;
              }
            } else {
              if (environment.isEnableBlockBrowser) {
                this.router.navigate([ugiftPath.browser.path]);
              }
            }
          }
        }
      });
    }

    this.initializeApp();
  }

  hidePopup() {
    $("#popup-check-logout").addClass("hidden");
    this.signOut();
  }

  hideNetworkPopup() {
    $("#popup-network-error").addClass("hidden");
  }

  hideTokenPopup() {
    $("#popup-expire-token").addClass("hidden");
    this.router.navigate([`${menuLoginPhone.path}`]);
  }

  hidePopup1() {
    $("#popup-check-campaignactive").addClass("hidden");
    this.router.navigate([`${menuHome.path}`]);
  }

  signOut() {
    if (localStorage.getItem(AppConsts.currentCustomerKey)) {
      localStorage.removeItem(AppConsts.currentCustomerKey);
    }
    this.staffServices.signOut();
    this.router.navigate([`${menuHome.path}`]);
  }
  exportReport() {
    $("#sidr-main").removeClass("left");
    this.router.navigate([menuReport.path]);
  }
  ngAfterViewInit() {
    //   this.activatedRoute.queryParams
    //   .subscribe(params => {
    //     if(params.phoneNumber){
    //       this.phoneNumber = params.phoneNumber;
    //       localStorage.setItem("phoneNumberScanQrFlow", JSON.stringify(params.phoneNumber));
    //     }
    //   }
    // );
  }
}
